module.exports = __webpack_public_path__ + "static/media/SERIED.4017c452.pdf";